import { useMemo } from 'react'

export function useContentWidth(width: number, maxWidth = 800): number {
  return useMemo(() => Math.max(Math.min(width * 0.95, maxWidth), 300), [width, maxWidth])
}
